import $ from 'jquery';
import "jquery-ui/ui/widgets/datepicker";
import "moment";


$(()=>{
  $(".js-date-pick").datepicker(
    {
      dateFormat: 'yy年mm月dd日 (DD)',
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      dayNames: ["日", "月", "火", "水", "木", "金", "土"],
    }
  );
});
